export const SET_VIEWPORT = 'SET_VIEWPORT'
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY'
